{
  "cancellation": {
    "confirmationTitle": "Cancel subscription",
    "confirmationBodyOne": "Are you sure you want to cancel your subscription",
    "confirmationBodyTwo": "You will no longer have acecess to your account and data after the subscription expires",
    "reasonHeadingOne": "We are sorry to see you leave.",
    "reasonHeadingTwo": "We'd love to get your input on how to make Iventis better.",
    "reasonSubheadingOne": "What is the main reason for cancelling?",
    "reasonSubheadingTwo": "Please provide any additional feedback",
    "reasonOne": "I am not getting complete use of Iventis",
    "reasonTwo": "I am finding it difficult to use",
    "reasonThree": "It does not have a feature I am looking for",
    "reasonFour": "It is too expensive",
    "reasonFive": "I have deciced to switch to another product",
    "reasonSix": "Other",
    "addComment": "Add a comment",
    "cancelSubscription": "Cancel subscription",
    "reactivate": "Reactivate your subscription",
    "success": "Your subscription has been cancelled and will expire on",
    "error": "There has been a problem cancelling your subscription. Please contact support.",
    "successReactivate": "You're project has been reactivated",
    "errorReactivate": "There has been a problem reactivating your subscription. Please contact support.",
    "contactUs": "Contact support",
    "nonAutomatedCancel": "Please contact support to cancel your subscription",
    "nonAutomatedReactivate": "Please contact support to reactivate your subscription",
    "cancelsOn": "Cancels on",
    "keepSubscription": "Keep subscription"
  },
  "limits": {
    "limitedResource": {
      "IndividualMap": "plans",
      "TeamMap": "plans",
      "User": "users"
    },
    "out_of": "{{ current }} out of {{ maximum }} active {{ resources }}",
    "users": {
      "limitReached": {
        "title": "User limit reached",
        "content": "You have reached the maximum number of users for this project. To add more users please"
      },
      "limitRemaining": {
        "title": "1 user remaining",
        "content": "You are about to reach the maximum number of users for this project. To add more users"
      }
    },
    "custom_layer": {
      "title": "Upgrade to customise your layer",
      "content": "Upgrade to our professional plan for limitless customisation or contact us at:"
    }
  }
}